import services from '../services'
import * as types from './mutation-types'

export const GetFaqs = ({ commit }, params) => (
  services.listFaqs(params).then(res => {
    commit(types.SET_FAQS, res.data)
  })
)

export const GetFaq = async ({ commit }, id) => {
  await services.getFaq(id).then(res => {
    commit(types.SET_FAQ, res.data.data)
  })
}

export const SaveFaq = async ({ commit }, obj) => {
  await services.saveFaq(obj).then(res => {
    commit(types.SET_FAQ, res.data.data)
    return res
  })
}

export const orderList = async ({ commit }, obj) => {
  await services.orderList(obj).then(res => {
    return res.data
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteFaq = async ({ commit }, obj) => {
  await services.deleteFaq(obj).then(res => {
    return res
  })
}
